import Interface from './Interface';

class PlainObject extends Interface {
    constructor() {
        super();
        this.storage = {};
    }

    get(key) {
        return this.storage[key] || null;
    }

    set(key, value) {
        this.storage[key] = value;
    }

    remove(key) {
        delete this.storage[key];
    }

  clear() {
    this.storage = {};
  }
}

export default PlainObject;


// WEBPACK FOOTER //
// ./src/common/auth/storage/drivers/PlainObject.js